'use es6';

import I18n from 'I18n';
export const getLanguageNameFromKey = key => I18n.text(`SharedI18nStrings.languageNames.${key}`);
export const isMasterTranslation = ({
  id,
  masterId,
  translatedFromId
}) => !masterId || id === translatedFromId;